import { useAFormHandler } from 'analytics/hooks'
import { useFormik } from 'formik'
import { CompanyCommercial, Prepayment } from 'modules/domain/company/types'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import ADefaultModalFooter from 'views/components/DefaultModalFooter/ADefaultModalFooter'
import { ASharedModal, SharedModalContent, SharedModalInputs, SharedModalTitle } from 'views/components/SharedModal'
import { AnalyticsPlaces } from '../analyticsPlaces'
import { CommonFields } from '../components/CommonFields'

type Props = {
  onClose: () => void
  refreshCompanies: (silent: boolean) => void
}

export type WorldCompanyFields = {
  prepayment?: keyof typeof Prepayment
  state_reg_number?: string
  payment_delay_days: number
  name: string | null
  inn?: string | null
  created?: string
  id?: number
  commercial: CompanyCommercial
  parent?: string
}

export const AddWorldCompany: FC<Props> = ({ onClose, refreshCompanies }) => {
  const { t } = useTranslation('company')
  const { formProgress, formHandler } = useAFormHandler()

  const formik = useFormik<WorldCompanyFields>({
    initialValues: {
      prepayment: Prepayment.unknown,
      state_reg_number: '',
      payment_delay_days: 0,
      name: null,
      inn: null,
      commercial: CompanyCommercial.unknown,
    },

    onSubmit: formHandler(async () => await apiClient.post<WorldCompanyFields>(endpoints.company(), formik.values), {
      onSuccess: async () => {
        await refreshCompanies(true)
        onClose()
      },
      onError: (error) => {
        const { errors } = error
        formik.setErrors(errors)
      },
    }),
  })

  return (
    <ASharedModal id={AnalyticsPlaces.DETAILS_MODAL} onClose={onClose}>
      <SharedModalTitle>{t('commonInfo')}</SharedModalTitle>
      <SharedModalContent>
        <SharedModalInputs>
          <CommonFields.NameCompany formik={formik} />
          <CommonFields.PersonalNumber formik={formik} />
          <CommonFields.RegNumber formik={formik} />
          <CommonFields.PrepaymentState formik={formik} />
          <CommonFields.PaymentDelayDays formik={formik} />
        </SharedModalInputs>
      </SharedModalContent>

      <ADefaultModalFooter
        confirmButtonText={t('common:save')}
        onConfirm={formik.handleSubmit}
        progress={formProgress}
        onClose={onClose}
      />
    </ASharedModal>
  )
}
